module.exports = __webpack_public_path__ + "static/img/data-use-bg.93bc750a.png";